import React from 'react';
import { Section } from './ui/Section';
import { Sun } from 'lucide-react';
export function Snapshot() {
  return <Section bg="white" className="border-y border-sage-100" data-id="element-159">
      <div className="max-w-3xl mx-auto text-center" data-id="element-160">
        <Sun className="w-12 h-12 text-terracotta mx-auto mb-8" data-id="element-161" />
        <p className="text-2xl md:text-3xl font-serif text-charcoal leading-relaxed italic" data-id="element-162">
          "Imagina despertar con la certeza de que tu cuerpo está recibiendo
          exactamente lo que necesita, en el momento correcto. No más náuseas
          por tomar lo que no debías en ayunas, no más dudas. Solo una rutina de
          salud optimizada y limpia."
        </p>
      </div>
    </Section>;
}